module.exports = __webpack_public_path__ + "img/private-chat.541b7225.svg";